import {SwiperListBaseModel} from "../swiper-list-base.model";
import {LiveStreamSwipeLogicHandler} from "../../swiper-logic-handler/live-stream-swipe-logic-handler";
import {Check} from "@sparkware/app-utils";
import {computed} from "mobx";
import React from "react";
import {
    VideoListLeftCutBox, VideoListNavigationNextButtonBox,
    VideoListNavigationPrevButtonBox, VideoListRightCutBox
} from "../../../../../components/live-streaming-tile/video-common-components/video-navigation/video-navigation.box";
import {VideoListComponent} from "../../../../../components/video-list-component/video-list.component";
import {IVideoListViewModel} from "./video-list-view-model.interface";

export abstract class DefaultVideoListModel extends SwiperListBaseModel implements IVideoListViewModel {
    protected _swipeLogicHandler: LiveStreamSwipeLogicHandler = new LiveStreamSwipeLogicHandler(this.services, this);

    protected get _isAISorted(): boolean {
        return false;
    }

    protected _getGameTypesOffsetFromLocalStorage(): number {
        let storedValue = this.services.localStorage.getItem(this._offsetStorageKey);

        return Check.isNullOrUndefined(storedValue) ? 0 : parseInt(storedValue);
    }

    protected _offsetStorageKey: string = 'orbit-video-list-gametype-offset' + this.listConfiguration.listId;

    /**
     * This must be static. Because the ListFactory.createSwiper will be called several times, and that will create a new instance of this class.
     * (For every live casino video list and every time the list changes and maybe when the ai changes the list sorting)
     * So if this is not "static" at every instance creation _gameTypesOffset will be initialized with "undefined"
     * and when calling _getGameTypes the cycling will run again for every new instance.
     * And we want to do this only once after page load
     */
    protected static _gameTypesOffsets: Record<string, number> = {};

    protected _cycleGamesAndIncrementOffset(baseArray: number[]) {
        if(Check.isNullOrUndefined(DefaultVideoListModel._gameTypesOffsets[this._offsetStorageKey])) {
            DefaultVideoListModel._gameTypesOffsets[this._offsetStorageKey] = this._getGameTypesOffsetFromLocalStorage();
            let newOffset = (DefaultVideoListModel._gameTypesOffsets[this._offsetStorageKey] + 1) % (this.listConfiguration.gamesId.length);
            this.services.localStorage.setItem(this._offsetStorageKey, newOffset);
        }

        return baseArray.splice(DefaultVideoListModel._gameTypesOffsets[this._offsetStorageKey]).concat(baseArray);
    }

    @computed
    get gameTypes(): number[] {
        // gameTypes is a getter and in javascript I cannot call "super.gameTypes"
        let gTypes = this._applyGameTypesTransformations(this._getGameTypes());

        if (this.services.mediaQuery.xlAndAbove && gTypes.length > 2) {
            let lastGame = gTypes.pop();
            gTypes.unshift(lastGame);
        }
        return gTypes;
    }

    renderListNavigation(): React.ReactElement | null {

        const PrevIcon = this.services.theme.currentTheme.icons.leftArrowIcon;
        const NextIcon = this.services.theme.currentTheme.icons.rightArrowIcon;

        return (
            <React.Fragment>
                {this.services.mediaQuery.xlAndAbove ?
                    <VideoListLeftCutBox>
                        <svg width="20" height="100%" viewBox="0 0 20 357">
                            <defs>
                                <filter id="Rectangle_1662" x="0" y="0" width="20" height="357" filterUnits="userSpaceOnUse">
                                    <feOffset dx="4" dy="3" />
                                    <feGaussianBlur stdDeviation="3" result="blur"/>
                                    <feFlood/>
                                    <feComposite operator="in" in2="blur"/>
                                    <feComposite in="SourceGraphic"/>
                                </filter>
                            </defs>
                            <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Rectangle_1662)">
                                <rect id="Rectangle_1662-2" data-name="Rectangle 1662" width="2" height="339" transform="translate(5 6)" fill="#262626"/>
                            </g>
                        </svg>
                    </VideoListLeftCutBox>
                    : null}
                <VideoListNavigationPrevButtonBox isActive={this.swipeLogicHandler.allowPrevious} onClick={() => this.swipeLogicHandler.movePrevious()}>
                    <PrevIcon size={3} style={{position: "absolute", top: "40%", left: "35%"}} />
                </VideoListNavigationPrevButtonBox>
                <VideoListNavigationNextButtonBox isActive={this.swipeLogicHandler.allowNext} onClick={() => this.swipeLogicHandler.moveNext()}>
                    <NextIcon size={3} style={{position: "absolute", top: "40%", right: "35%"}} />
                </VideoListNavigationNextButtonBox>
                {this.services.mediaQuery.xlAndAbove ?
                    <VideoListRightCutBox>
                        <svg width="20" height="100%" viewBox="0 0 20 357">
                            <defs>
                                <filter id="Rectangle_1663" x="0" y="0" width="20" height="357" filterUnits="userSpaceOnUse">
                                    <feOffset dx="-4" dy="3" />
                                    <feGaussianBlur stdDeviation="3" result="blur"/>
                                    <feFlood/>
                                    <feComposite operator="in" in2="blur"/>
                                    <feComposite in="SourceGraphic"/>
                                </filter>
                            </defs>
                            <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Rectangle_1663)">
                                <rect id="Rectangle_1663-2" data-name="Rectangle 1663" width="2" height="339" transform="translate(13 6)" fill="#262626"/>
                            </g>
                        </svg>
                    </VideoListRightCutBox>
                    : null}
            </React.Fragment>
        );
    }



    _renderList(listPosition: number): React.ReactElement | null {
        return (
            <VideoListComponent
                key={this.listKey}
                viewModel={this}
                listPosition={listPosition}
            />
        );
    }

    setCurrentGameIndex(gameIndex: number): void {
        this._swipeLogicHandler.setCurrentGameIndex(gameIndex);
    }
}
